<template>
    
    <v-card :disabled="readOnly">

        <MessageOverlay ref="overlay" />

        <v-form ref="form" v-model="validForm" lazy-validation> 
            <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-alert outlined color="black" class="mb-0">
                            <v-tabs v-model="tab" centered fixed-tabs class="mb-2">
                                <v-tab>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.alarmparameters') }} </v-tab>
                                <v-tab>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.intrusionparameters') }}</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">  
                                <v-tab-item>
                                    <v-container> 
                                        <v-row justify="center" class="mt-0" :dense="$vuetify.breakpoint.xs">
                                            <v-col cols="5">
                                                <v-text-field
                                                    v-model="triggerThreshold"
                                                    outlined
                                                    required
                                                    :rules="thresholdRules"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.triggerthreshold')+'*'"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="1" class="ml-n9 mt-n2">
                                                <v-tooltip bottom :open-on-click="false" :open-on-focus="false" nudge-left="150">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-on="on" v-bind="attrs"  color="grey">mdi-information</v-icon>
                                                    </template>
                                                    <h3>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.thresholdInfo') }}</h3>
                                                    <div>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.thresholdInfo1') }}</div>
                                                    <div>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.thresholdInfo2') }}</div>
                                                </v-tooltip>
                                            </v-col>

                                            <v-col cols="5">
                                                <v-text-field
                                                    v-model="localUTC.emissivity"
                                                    outlined
                                                    required
                                                    :rules="emissivityRules"
                                                    :label= "$vuetify.lang.t('$vuetify.utc.controlsCard.emissivity')+'*'"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-divider />
                                        <div align="center" class="mt-4 mb-3 text-subtitle-1">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.advancedconfiguration') }}</div>
                                        <v-row class="mt-0" :dense="$vuetify.breakpoint.xs">
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model="localUTC.hysteresis"
                                                    outlined
                                                    required
                                                    :rules="hysteresisRules"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.hysteresis')+ ' (°C)*'"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model="localUTC.entryTimeSec"
                                                    outlined
                                                    required
                                                    :rules="entryDelayRules"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.entryDelay')+ ' (s)*'"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-text-field
                                                    v-model="localUTC.exitTimeHour"
                                                    outlined
                                                    required
                                                    :rules="exitDelayRules"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.exitDelay')+ ' (s)*'"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-divider />
                                        <div align="center" class="mt-4 mb-3 text-subtitle-1">{{$vuetify.lang.t('$vuetify.utc.controlsCard.frequency')}} : 1 image {{$vuetify.lang.t('$vuetify.utc.controlsCard.every')}}</div>
                                        <v-row class="mt-0">
                                            <v-col cols="6" class="pb-0">
                                                <v-select
                                                    v-model="localUTC.alarmFreqNb"
                                                    outlined
                                                    :items="freq_nbList"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.multiplier')"
                                                ></v-select>
                                            </v-col>                                        
                                            <v-col cols="6" class="pb-0">
                                                <v-select
                                                    v-model="alarm_freq_index"
                                                    outlined
                                                    :items='freq_indexList'
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.period')"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-divider />
                                        <div align="center" class="mt-2 text-subtitle-1">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.signals') }}</div>
                                        <v-row align="center" justify="space-around" class="mt-0">
                                            <v-col cols="auto">
                                                <v-checkbox
                                                    v-model="localUTC.alarmSoundOn"
                                                    hide-details
                                                    class="mt-0"
                                                >
                                                    <template v-slot:label>
                                                        <v-icon
                                                            left
                                                            large
                                                            :color="localUTC.alarmSoundOn ? 'green' : ''"
                                                            :disabled="!localUTC.alarmSoundOn"
                                                        >
                                                            {{ localUTC.alarmSoundOn ? 'mdi-volume-high' : 'mdi-volume-off' }}
                                                        </v-icon>
                                                        <span>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.sound') }}</span>
                                                    </template>
                                                </v-checkbox>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-checkbox
                                                    v-model="localUTC.alarmFlagDisplayOn"
                                                    hide-details
                                                    class="mt-0"
                                                >
                                                    <template v-slot:label>
                                                        <v-icon
                                                            left
                                                            large
                                                            :color="localUTC.alarmFlagDisplayOn ? 'green' : ''"
                                                            :disabled="!localUTC.alarmFlagDisplayOn"
                                                        >
                                                            mdi-alarm-light
                                                            {{ localUTC.alarmFlagDisplayOn ? 'mdi-eye' : 'mdi-eye-off' }}
                                                        </v-icon>
                                                        <span>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.alarmindicator') }}</span>
                                                    </template>
                                                </v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-divider class="mt-2 mb-5"/>
                                        <v-row justify="center">
                                            <v-btn
                                                dark
                                                hide-details
                                                class="gradient-wintech"
                                                @click="openMasksOrThermographDialog('masks')"
                                            >
                                                <v-icon left>mdi-square-opacity</v-icon>
                                                {{ $vuetify.lang.t('$vuetify.utc.controlsCard.maskedition') }}
                                            </v-btn>
                                        </v-row>
                                    </v-container>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-container>
                                        <v-row justify="center" class="mt-5">
                                            <v-col cols="auto">
                                                <div align="center" class="mt-4 mb-3 text-subtitle-1">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.intrusion') }}</div>
                                            </v-col> 
                                            <v-col cols="auto">
                                                <v-switch
                                                v-model="localUTC.intrusionOn"
                                                hide-details
                                                inset
                                            ></v-switch>
                                            </v-col>                                                
                                        </v-row>
                                        <v-row class="mt-5" :dense="$vuetify.breakpoint.xs" justify="center">
                                            <v-col cols="11">
                                                <v-select 
                                                    v-model="localUTC.intrusionMode"
                                                    outlined
                                                    :items="intrusionModeList"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.mode')"
                                                    disabled
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="1" class="mt-4">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-on="on" v-bind="attrs">
                                                            <v-icon> mdi-information</v-icon>
                                                        </div>
                                                    </template>                                 
                                                    <span>{{$vuetify.lang.t('$vuetify.utc.controlsCard.modeselectionlocked')}}</span>
                                                </v-tooltip>

                                            </v-col>                                         
                                        </v-row>
                                        <v-divider />
                                        <div align="center" class="mt-6 mb-3 text-subtitle-1">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.advancedconfiguration') }}</div>
                                        <v-row class="mt-1" :dense="$vuetify.breakpoint.xs">
                                            <v-col cols="12" sm="6">
                                                <v-text-field
                                                    v-model="localUTC.entryTimeSecIntr"
                                                    outlined
                                                    required
                                                    :rules="entryDelayIntRules"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.entryDelay')+ ' (s)*'"
                                                    :disabled="!localUTC.intrusionOn"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field
                                                    v-model="localUTC.exitTimeSecIntr"
                                                    outlined
                                                    required
                                                    :rules="exitDelayIntRules"
                                                    :label="$vuetify.lang.t('$vuetify.utc.controlsCard.exitDelay')+ ' (s)*'"
                                                    :disabled="!localUTC.intrusionOn"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-divider />
                                        <div align="center" class="mt-5 text-subtitle-1">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.signals') }}</div>
                                        <v-row align="center" justify="space-around" class="mt-0 mb-0">
                                            <v-col cols="auto">
                                                <v-checkbox
                                                    v-model="localUTC.intrusionSoundOn"
                                                    hide-details
                                                    class="mt-0"
                                                    :disabled="!localUTC.intrusionOn"
                                                >
                                                    <template v-slot:label>
                                                        <v-icon
                                                            left
                                                            large
                                                            :color="localUTC.intrusionSoundOn ? 'green' : ''"
                                                            :disabled="!localUTC.intrusionOn" 
                                                        >
                                                            {{ localUTC.intrusionSoundOn ? 'mdi-volume-high' : 'mdi-volume-off' }}
                                                        </v-icon>
                                                        <span>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.sound') }}</span>
                                                    </template>
                                                </v-checkbox>  
                                            </v-col> 
                                            <v-col cols="auto">
                                                <v-checkbox
                                                    v-model="localUTC.intrusionFlagDisplayOn"
                                                    hide-details
                                                    class="mt-0"
                                                    :disabled="!localUTC.intrusionOn"
                                                >
                                                    <template v-slot:label>
                                                        <v-icon
                                                            left
                                                            large
                                                            :color="localUTC.intrusionFlagDisplayOn ? 'green' : ''"
                                                            :disabled="!localUTC.intrusionOn"
                                                        >
                                                            mdi-alarm-light
                                                            {{ localUTC.intrusionFlagDisplayOn ? 'mdi-eye' : 'mdi-eye-off' }}
                                                        </v-icon>
                                                        <span>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.alarmindicator') }}</span>
                                                    </template>
                                                </v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-alert>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-alert outlined color="black" >
                            <h2 align="center">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.customization') }}</h2>
                            <v-row justify="space-around" align="center" class="mt-3"> 
                                <v-col cols="auto">
                                    <v-text-field
                                        v-model="localUTC.denomination"
                                        hide-details
                                        outlined
                                        required
                                        :rules="denominationRules"
                                        :label="$vuetify.lang.t('$vuetify.utc.controlsCard.denomination')+'*'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="auto">
                                    <v-checkbox
                                        v-model="localUTC.isNotificationActive"
                                        hide-details
                                        class="mt-0"
                                    >
                                        <template v-slot:label>
                                            <v-icon
                                                left
                                                large
                                                :color="localUTC.isNotificationActive ? 'green' : ''"
                                                :disabled="!localUTC.isNotificationActive"
                                            >
                                                {{ localUTC.isNotificationActive ? 'mdi-bell-ring-outline' : 'mdi-bell-off-outline' }}
                                            </v-icon>
                                            <span>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.notifications') }}<sup>(1)</sup></span>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row justify="space-around" align="center" class="mt-3">
                                <v-col cols="auto" class="mt-n5">
                                    <fieldset style="border-width: 1px; border-color: rgba(0, 0, 0, 0.38); border-style: solid; border-radius: 4px; font-size: 13px;" class="pa-3">
                                        <legend class="px-1" style="color: rgba(0, 0, 0, 0.6); letter-spacing: normal">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.degree') }}</legend>
                                        <v-radio-group v-model="localUTC.degFormat">
                                            <v-radio
                                                :value="'C'"
                                                :label="'°C (Celsius)'"
                                            ></v-radio>
                                            <v-radio
                                                :value="'F'"
                                                :label="'°F (Fahrenheit)'"
                                            ></v-radio>
                                            <v-radio
                                                :value="'K'"
                                                :label="'°K (Kelvin)'"
                                            ></v-radio>
                                        </v-radio-group>
                                    </fieldset>
                                </v-col>
                                <v-divider vertical class="d-none d-sm-flex my-5 mb-10"></v-divider>
                                <v-col cols="12" sm="5">
                                    <v-select v-model="localUTC.dateFormat" label="Date" :items="dateFormatList" outlined class="mt-n3"></v-select>
                                    <v-select v-model="localUTC.timeFormat" :label="$vuetify.lang.t('$vuetify.utc.controlsCard.time')" :items="timeFormatList" outlined class="mt-n3"></v-select>                                    
                                    <v-select v-model="localUTC.lang" :label="$vuetify.lang.t('$vuetify.utc.controlsCard.language')" :items="LanguageList" outlined class="mt-n3"></v-select>    
                                </v-col>
                            </v-row>
                            <v-row class="mt-n7 mb-3" align="center" justify="center">
                                    <v-checkbox
                                        v-model="localUTC.photoActive"
                                        hide-details
                                        class="mt-n2"
                                    ></v-checkbox>
                                    <div align="center" class="text-subtitle-1 font-weight-bold">{{$vuetify.lang.t('$vuetify.utc.controlsCard.progScreen')}}</div>
                            </v-row>
                            <v-row >
                                <v-col cols="6" class="pb-0 mt-n3">
                                    <v-select
                                        v-model="localUTC.photoFreqNb"
                                        outlined
                                        :disabled="!localUTC.photoActive"
                                        :items="freq_nbList"
                                        :label="$vuetify.lang.t('$vuetify.utc.controlsCard.multiplier')"
                                    ></v-select>
                                </v-col>                                        
                                <v-col cols="6" class="pb-0 mt-n3">
                                    <v-select
                                        v-model="photo_freq_index"
                                        outlined
                                        :disabled="!localUTC.photoActive"
                                        :items='freq_indexList'
                                        :label="$vuetify.lang.t('$vuetify.utc.controlsCard.period')"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <div class="text-caption mt-n5">(1) {{ $vuetify.lang.t('$vuetify.utc.controlsCard.warningnotif') }}</div>
                            <v-divider class="my-4"></v-divider>
                            <v-row justify="center" class="mt-3 mb-3">
                                <v-btn
                                    dark
                                    color="grey"
                                    class="gradient-wintech"
                                    :small="$vuetify.breakpoint.xs"
                                    @click="openMasksOrThermographDialog('thermograph')"
                                >
                                    <v-icon left>mdi-square-edit-outline</v-icon>
                                    {{ $vuetify.lang.t('$vuetify.utc.controlsCard.thermographoptions') }}

                                </v-btn>
                            </v-row>
                        </v-alert>
                        <v-card-actions class="px-0">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        dark
                                        fab
                                        dense
                                        :small="$vuetify.breakpoint.xs"
                                        class="mr-2 gradient-wintech"
                                        @click="takeScreenshot"
                                    >
                                        <v-icon>mdi-camera-wireless</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.takeapictureremotely') }}</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        dark
                                        fab
                                        :small="$vuetify.breakpoint.xs"
                                        class="mr-2 gradient-wintech"
                                        @click="findMe"
                                    >
                                        <v-icon>mdi-map-marker-radius-outline</v-icon>
                                    </v-btn>
                                </template>                                 
                                <span>{{ $vuetify.lang.t('$vuetify.utc.controlsCard.activateavisualeffectremotelyonutcahelptofindandidentifyit') }}</span>
                            </v-tooltip>
                            <v-spacer />
                            <v-btn
                                :small="$vuetify.breakpoint.xs"
                                :disabled="!hasDataChanged || !validForm"
                                :class="!hasDataChanged || !validForm ? '' : 'gradient-wintech'"
                                @click="updateUTCInfos"
                            >
                                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-content-save</v-icon>
                                <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.save') }}</template>
                            </v-btn>
                            <v-btn
                                color="error"
                                :small="$vuetify.breakpoint.xs"
                                :disabled="!hasDataChanged"   
                                @click="reset"
                            >
                                <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-backup-restore</v-icon>
                                <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.utc.controlsCard.reset') }}</template>
                            </v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

        <MaskDetail
            v-if="lastScreenshot"
            :open="showPopUpMask"
            :serialnb="utcInfos.serialnb"
            :lastScreenshot="lastScreenshot"
            :masks.sync="masks"
            :regions="regions"
            :points="points"
            :regionRules="regionRules"
            :pointRules="pointRules"
            @close="showPopUpMask=false"
        />

        <AdvancedOptionsDetail
            v-if="lastScreenshot"
            :open="showPopUpThermograph"
            :serialnb="utcInfos.serialnb"
            :lastScreenshot="lastScreenshot"
            :regions.sync="regions"
            :points.sync="points"
            :regionRules.sync="regionRules"
            :pointRules.sync="pointRules"
            :masks="masks"
            @close="showPopUpThermograph=false"
        />
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import MaskDetail from './ControlsCard/MaskDetail.vue';
    import AdvancedOptionsDetail from './ControlsCard/AdvancedOptionsDetail.vue';
    import MessageOverlay from '@/components/Overlay/MessageOverlay.vue'
    var cloneDeep = require('lodash.clonedeep');
    var tiff = require('tiff');
    
    export default {
        name: "ControlsCard",

        components: {
            MaskDetail, 
            AdvancedOptionsDetail,    
            MessageOverlay,
        },

        props: {
            utcInfos: Object,
        },
        
        data() {
            return {
                model: false,
                localUTC: cloneDeep(this.utcInfos),
                validForm: true,
                dateFormatList: ['dd/MM/yyyy','MM/dd/yyyy', 'yyyy/MM/dd'],
                timeFormatList: ['hh:mm:ss','hh:mm','hh:mm:ss AP','hh:mm AP'],
                LanguageList: ['en_US', 'fr_FR', 'es_ES'],
                freq_indexList: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.utc.controlsCard.minute'),
                        value: 0
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.utc.controlsCard.hour'),
                        value: 1
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.utc.controlsCard.day'),
                        value: 2
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.utc.controlsCard.week'),
                        value: 3
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.utc.controlsCard.month'),
                        value: 4
                    }
                ],
                freq_nbList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 11, 12, 13, 14, 15,
                             16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
                emissivityRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.emissivityisrequired'),
                    v => /^\d+(?:\.\d{1,6})?$/.test(v)  || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theemissivityvaluemustbeapositiverealnumber'),

                ],
                hysteresisRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.hysteresisisrequired'),
                    v => /^\d+(?:\.\d{1,6})?$/.test(v)  || this.$vuetify.lang.t('$vuetify.utc.controlsCard.thehysteresisvaluemustbeapositiverealnumber'),
                    v => (v >= 0 && v <= 20) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theHysteresisvaluemustbebetween0and20'),

                ],
                entryDelayRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.entryDelayisrequired'),
                    v => Number.isInteger(Number(v)) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),
                    v => (v >= 0 && v <= 300) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theEntryDelayvaluemustbebetween0and300'),
                    v => !/[.,]/.test(v) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),

                ],
                exitDelayRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.exitDelayisrequired'),
                    v => Number.isInteger(Number(v)) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),
                    v => (v >= 0 && v <= 604800) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theExitDelayvaluemustbebetween0and604800'),
                    v => !/[.,]/.test(v) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),           

                ],
                entryDelayIntRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.entryDelayisrequired'),
                    v => Number.isInteger(Number(v)) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),
                    v => (v >= 1 && v <= 60) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theEntryDelayvalueIntmustbebetween1and60'),
                    v => !/[.,]/.test(v) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),

                ],
                exitDelayIntRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.exitDelayisrequired'),
                    v => Number.isInteger(Number(v)) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),
                    v => (v >= 10 && v <= 600) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theExitDelayvalueIntmustbebetween10and600'),
                    v => !/[.,]/.test(v) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.theDelayvaluemustbeaninteger'),            

                ],
                thresholdRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.thresholdisrequired'),
                    v => /^\d+(?:\.\d{1,6})?$/.test(v)  || this.$vuetify.lang.t('$vuetify.utc.controlsCard.thethresholdvaluemustbeapositiverealnumber'),
                    v => (v >= this.convert(this.utcInfos.calibMin) && v <= this.convert(this.utcInfos.calibMax)) || this.$vuetify.lang.t('$vuetify.utc.controlsCard.thethresholdvaluemustbebetween') + this.convert(this.utcInfos.calibMin) + this.$vuetify.lang.t('$vuetify.utc.controlsCard.and') + this.convert(this.utcInfos.calibMax)
                ],
                denominationRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.utc.controlsCard.denominationisrequired'),
                ],

                intrusionModeList: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.utc.controlsCard.permanent'),
                        value: 0
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.utc.controlsCard.night'),
                        value: 1
                    }
                ],

                showPopUpMask: false,
                showPopUpThermograph: false,
                masks: [],
                regions: [],
                points: [],
                regionRules: [],
                pointRules: [],
                lastScreenshot: undefined,
                tab: 0,
                defaultValueEntry: 2,
                defaultValueExit: 10,
            }
        },

        computed: {
            ...mapGetters({ user: 'StateUser' }),
            readOnly() {
                return ['EXPLOITATION', 'ADMINISTRATION'].indexOf(this.user.role) === -1
            },

            alarm_freq_index:{
                get() {
                    return this.freq_indexList[this.localUTC.alarmFreqIndex];
                },
                set(e) {
                    this.localUTC.alarmFreqIndex = e;
                }
            },

            photo_freq_index:{
                get() {
                    return this.freq_indexList[this.localUTC.photoFreqIndex];
                },
                set(e) {
                    this.localUTC.photoFreqIndex = e;
                }
            },

            triggerThreshold: {
                get() {
                    return this.convert(this.localUTC.threshold);
                },
                set(e) {
                    this.localUTC.threshold = this.convertback(e);
                },
            },

            hasDataChanged() {
                return !(this.utcInfos.threshold==this.localUTC.threshold && this.utcInfos.emissivity==this.localUTC.emissivity &&
                    this.utcInfos.hysteresis==this.localUTC.hysteresis && this.utcInfos.entryTimeSec==this.localUTC.entryTimeSec && this.utcInfos.exitTimeHour==this.localUTC.exitTimeHour &&
                    this.utcInfos.alarmFreqNb==this.localUTC.alarmFreqNb && this.utcInfos.alarmFreqIndex==this.localUTC.alarmFreqIndex &&
                    this.utcInfos.photoFreqNb==this.localUTC.photoFreqNb && this.utcInfos.photoFreqIndex==this.localUTC.photoFreqIndex && (+this.utcInfos.photoActive)==this.localUTC.photoActive &&
                    this.utcInfos.alarmSoundOn==this.localUTC.alarmSoundOn && this.utcInfos.alarmFlagDisplayOn==this.localUTC.alarmFlagDisplayOn &&
                    this.utcInfos.denomination==this.localUTC.denomination && (+this.utcInfos.isNotificationActive)==this.localUTC.isNotificationActive &&
                    this.utcInfos.degFormat==this.localUTC.degFormat && this.utcInfos.dateFormat==this.localUTC.dateFormat &&
                    this.utcInfos.timeFormat==this.localUTC.timeFormat && this.utcInfos.lang==this.localUTC.lang && this.utcInfos.intrusionSoundOn == this.localUTC.intrusionSoundOn && this.utcInfos.intrusionFlagDisplayOn == this.localUTC.intrusionFlagDisplayOn &&
                    this.utcInfos.entryTimeSecIntr == this.localUTC.entryTimeSecIntr && this.utcInfos.exitTimeSecIntr == this.localUTC.exitTimeSecIntr && 
                    this.utcInfos.intrusionOn == this.localUTC.intrusionOn && this.utcInfos.intrusionMode == this.localUTC.intrusionMode 

                )
            },
        },

        async created() {
            await Promise.all([ this.getRegions(), this.getPoints(), this.getMasks(), this.getRegionRules(), this.getPointRules() ]);
        },

        watch: {
            async utcInfos(newUtcInfos) {
                this.localUTC = cloneDeep(newUtcInfos);
                await Promise.all([ this.getRegions(), this.getPoints(), this.getMasks(), this.getRegionRules(), this.getPointRules() ]);
            }
        },

        methods: {
            async takeScreenshot() {
                try {
                    const res = await axios.post('utcs/'+ this.utcInfos.serialnb +'/takeScreenshot');
                    if (res.status == 200) {
                        this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.utc.controlsCard.screenshotOrdersentOK'));
                    }
                } catch(err) {
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.utc.controlsCard.screenshotOrdersentERR'));
                }
            },
            async findMe() {
                try {
                    const res = await axios.post('utcs/'+ this.utcInfos.serialnb +'/findMe');
                    if (res.status == 200) {
                        this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.utc.controlsCard.findmeOrdersentOK'));
                    }
                } catch(err) {
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.utc.controlsCard.findmeOrdersentERR'));
                }
            },

            async updateUTCInfos() {
                const cmd= "\"DENOMINATION\":\""+this.localUTC.denomination+"\",\"LANG\":\""+this.localUTC.lang+"\",\"THRESHOLD\":\""+this.localUTC.threshold+"\",\"EMISSIVITY\":\""+this.localUTC.emissivity+
                "\",\"DEGREE\":\""+this.localUTC.degFormat+"\",\"DATE\":\""+this.localUTC.dateFormat+"\",\"TIME\":\""+this.localUTC.timeFormat+"\",\"ALARM_FREQ_NB\":\""+this.localUTC.alarmFreqNb+"\",\"ALARM_FREQ_INDEX\":\""+this.localUTC.alarmFreqIndex+"\",\"PHOTO_FREQ_NB\":\""+this.localUTC.photoFreqNb+"\",\"PHOTO_FREQ_INDEX\":\""+this.localUTC.photoFreqIndex+"\",\"PHOTO_ACTIVE\":\""+(+this.localUTC.photoActive)+"\",\"ALARM_FLAG\":\""+
                (+this.localUTC.alarmFlagDisplayOn)+"\",\"ALARM_SOUND\":\""+(+this.localUTC.alarmSoundOn)+"\",\"NOTIFICATION\":\""+(+this.localUTC.isNotificationActive)+"\",\"ENTRY_DELAY\":\""+this.localUTC.entryTimeSec+"\",\"EXIT_DELAY\":\""+this.localUTC.exitTimeHour+"\",\"HYSTERESIS\":\""+
                this.localUTC.hysteresis+"\",\"INTRUSION_BOOL\":\""+(+this.localUTC.intrusionOn)+"\",\"INTRUSION_MODE\":\""+this.localUTC.intrusionMode+"\",\"ENTRY_TIME_SEC_INTR\":\""+this.localUTC.entryTimeSecIntr+"\",\"EXIT_TIME_SEC_INTR\":\""+this.localUTC.exitTimeSecIntr+"\",\"INTRUSION_SOUND_ON\":\""+
                (+this.localUTC.intrusionSoundOn)+"\",\"INTRUSION_FLAG_DISPLAY_ON\":\""+(+this.localUTC.intrusionFlagDisplayOn)+"\""
                
                try {
                    const res = await axios.put('utcs/'+ this.localUTC.serialnb, {
                        cmd: cmd
                    });
                    if (res.status == 200) {
                        this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.utc.controlsCard.updateSettingsOrdersentOK'));
                        this.$emit('validate', cloneDeep(this.localUTC));
                    }
                } catch(err) {
                    this.$refs.overlay.showOverlay("error",  this.$vuetify.lang.t('$vuetify.utc.controlsCard.controlsCard.updateSettingsOrdersentERR'));
                }
            },

            convert(val){
                return this.localUTC.degFormat === 'C' ? val : this.localUTC.degFormat === 'F' ? (val*9/5)+32 : Number(val)+273.15
            },

            convertback(val){
                return this.localUTC.degFormat === 'C' ? val : this.localUTC.degFormat === 'F' ? (val-32)*5/9 : Number(val)-273.15;
            },

            updateFiltersSelectedWithQuery() {
                let selection = [];
                for (const key of Object.keys(this.$route.query)) {
                    if (['critical', 'warning', 'notRecom', 'ok'].indexOf(key) !== -1) selection.push(key)
                }
                this.filtersList = selection;
            },
                
            reset() {
                this.localUTC = cloneDeep(this.utcInfos);
            },

            async openMasksOrThermographDialog(dialog) {
                this.lastScreenshot = undefined;
                await this.getImages(this.utcInfos.serialnb);
                if (dialog === "masks") {
                    this.showPopUpMask = true;                              
                } else if (dialog === "thermograph") {
                    this.showPopUpThermograph = true;
                } 
            },

            async getImages(serialnb) {
                try {
                    const res = await axios.get('images/1/screenshots/'+ serialnb + '/'+this.user.orga);
                    if (res.status == 200) {
                        let images = res.data;
                        if (images === "No Screenshot") {
                            let emptyScreenshot = {};
                            emptyScreenshot.tiff = undefined;
                            emptyScreenshot.url = undefined;
                            emptyScreenshot.loading = false;
                            this.lastScreenshot = emptyScreenshot;
                        } else {
                            await this.getImageBlob(images);
                        }
                    }
                } catch(error){
                    console.error(error);
                }         
            },

            async getImageBlob(img) {
                try {
                    const res = await axios.get('images/screenshots/' + img.name+"/"+this.user.orga, { responseType: 'blob' });
                    const blob = res.data;                        
                    const objectUrl = URL.createObjectURL(blob);
                    let newScreenshot = img;
                    newScreenshot.blob = blob;
                    newScreenshot.arraybuffer = await blob.arrayBuffer();
                    try {
                        newScreenshot.tiff = tiff.decode(newScreenshot.arraybuffer); 
                    } catch (err) {
                        newScreenshot.tiff = undefined;
                    }
                    newScreenshot.url = objectUrl;
                    newScreenshot.loading = false;
                    this.lastScreenshot = newScreenshot;
                } catch(error) {
                    console.error(error)
                }      
            },

            async getRegions() {
                try {
                    const res = await axios.get('areapoint/region/'+ this.utcInfos.serialnb);
                    if (res.status == 200) {
                        this.regions = res.data;
                    }
                } catch(error) {
                    console.error(error)
                }
            },

            async getPoints() {
                try {
                    const res = await axios.get('areapoint/point/'+ this.utcInfos.serialnb);
                    if (res.status == 200) {
                        this.points = res.data;
                    }
                } catch(error) {
                    console.error(error);
                }
            },

            async getMasks() {
                try {
                    const res = await axios.get('areapoint/mask/'+ this.utcInfos.serialnb);
                    if (res.status == 200) {
                        this.masks = res.data
                    }
                } catch(error) {
                    console.error(error)
                }
            },

            async getRegionRules() {
                try {
                    const res = await axios.get('areapoint/regionRules/'+ this.utcInfos.serialnb);
                    if (res.status == 200) {
                        this.regionRules = res.data;
                    }
                } catch(error) {
                    console.error(error)
                }
            },

            async getPointRules() {
                try {
                    const res = await axios.get('areapoint/pointRules/'+ this.utcInfos.serialnb);
                    if (res.status == 200) {
                        this.pointRules = res.data;
                    }
                } catch(error) {
                    console.error(error);
                }
            },
        },
    }   
</script>